const productGroupData = ['men', 'women'];

export default productGroupData;
